import React from "react"
import { Dimmer, Flex, Button } from "@jjordy/layout"
import { FaTimesCircle } from "react-icons/fa"
import styled from "../styled"
import HoverGrow from "../Animations/HoverGrow"

const CloseButton = styled(Button)`
  height: 32px;
  width: 128px;
  border-radius: 0px;
  border-top-right-radius: 3px;
  margin: 0;
  outline: none;
`

const Message = styled.div<{ wide?: boolean }>`
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 3px;
  border: 1px solid #e7e7e7;
  box-shadow: 1px 1px 1px #e7e7e7;
  width: ${(props: any) => (props.wide ? "1140px" : "768px")};
  @media (max-width: 768px) {
    width: 98%;
  }
`

export interface ModalProps {
  active?: boolean
  wide?: boolean
  children: React.ReactNode
  onClose?: () => void
}

export default function Modal({ active, children, onClose, wide = false }: ModalProps) {
  return (
    <Dimmer active={active} page>
      <Message wide={wide}>
        <Flex justify="flex-end">
          <HoverGrow>
            <CloseButton onClick={onClose} bg="red">
              X
            </CloseButton>
          </HoverGrow>
        </Flex>
        {children}
      </Message>
    </Dimmer>
  )
}
